function escapeForUrl(value) {
  if (!value) return '';

  return value.toString()
    .replace(/\&/i, 'and')
    .replace(/[^a-z0-9/]/ig, '-')

    .split('-')
    .filter(x => x)
    .join('-')

    .toLowerCase();
}

module.exports = escapeForUrl;
